import {Component, Inject, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import {RadioModalData, RadioModalDataType} from "@portal/shared/models/radio-modal-data";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/input';
import { MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from '@angular/material/datepicker';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-group-selection-modal',
    templateUrl: './group-selection-modal.component.html',
    styleUrls: ['./group-selection-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatRadioGroup, FormsModule, MatRadioButton, MatFormField, MatLabel, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatSuffix, MatDateRangePicker, MatCheckbox, MatDialogActions, MatButton, MatDialogClose]
})
export class GroupSelectionModalComponent {
    selectedOption: number;
    selectedOptions: number[] = [];
    RadioModalDataType = RadioModalDataType;
    startDate: Date;
    endDate: Date;
    constructor(
        public dialogRef: MatDialogRef<GroupSelectionModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RadioModalData) { }

    isTypeIncluded(type: RadioModalDataType): boolean {
        return this.data.types.includes(type);
    }

    confirmSelection() {
        let result = {};

        if (this.isTypeIncluded(RadioModalDataType.Radio)) {
            result = { ...result, selectedOption: this.selectedOption };
        }

        if (this.isTypeIncluded(RadioModalDataType.BetweenDates)) {
            result = { ...result, startDate: this.startDate, endDate: this.endDate };
        }

        if (this.isTypeIncluded(RadioModalDataType.Checkbox)) {
            result = { ...result, selectedOptions: this.selectedOptions };
        }

        this.dialogRef.close(result);
    }

}
